import { Table } from '@consta/uikit/Table'
import { assertToBeDefine } from '@core/core/utils'
import type { WellId } from 'common/types'
import type { FC } from 'react'
import { useState } from 'react'

import type { OnChangeVspOffsetFunc } from '../../types'
import { NotFoundSearch, NotFoundWellInField } from '../Errors'
import { getWellsTableColumns } from './helpers'
import type { OnRowClick, RowWellVsp } from './types'
import css from './WellsTable.css'

export type WellsTableProps = {
  isFieldEmpty?: boolean
  hasNextStep: boolean
  wellVsp: RowWellVsp[]
  checkedWells?: Set<WellId>
  onRowClick?: (row: RowWellVsp) => void
  onCheck?: (wellId: WellId) => void
  onChangeVspOffset?: OnChangeVspOffsetFunc
}

export const WellsTable: FC<WellsTableProps> = ({
  isFieldEmpty,
  hasNextStep,
  wellVsp,
  checkedWells,
  onRowClick,
  onCheck,
  onChangeVspOffset,
}) => {
  const [hoveredRowId, setHoveredRowId] = useState<string>()

  const handleCellClick: OnRowClick = ({ id, e: { target, currentTarget } }) => {
    if (target === currentTarget) {
      return
    }

    const clicked = wellVsp.find(item => item.id === id)

    assertToBeDefine(clicked)

    onRowClick?.(clicked)
  }

  if (isFieldEmpty) {
    return <NotFoundWellInField />
  }

  if (wellVsp.length === 0) {
    return <NotFoundSearch />
  }

  return (
    <Table
      className={css.wellsTable}
      columns={getWellsTableColumns(
        hasNextStep,
        hoveredRowId,
        checkedWells,
        onCheck,
        onChangeVspOffset,
      )}
      rows={wellVsp}
      size="s"
      verticalAlign="center"
      stickyHeader={true}
      lazyLoad={{ maxVisibleRows: 100, scrollableEl: window }}
      onRowHover={({ id }) => {
        setHoveredRowId(id)
      }}
      onRowClick={handleCellClick}
    />
  )
}
